/* ============================================
   HEADER — header.js
   Mega menu, mobile drawer.
   ============================================ */
(function() {
'use strict';
/* ── Mega Menu ── */
var megaWrap    = document.querySelector('[data-mega]');
var triggers    = document.querySelectorAll('[data-mega-trigger]');
var panels      = document.querySelectorAll('[data-mega-panel]');
var overlay     = document.querySelector('[data-mega-overlay]');
var hoverTimer  = null;
function openPanel(name) {
clearTimeout(hoverTimer);
panels.forEach(function(p) { p.classList.remove('is-active'); });
var target = document.querySelector('[data-mega-panel="' + name + '"]');
if (target) {
target.classList.add('is-active');
megaWrap.classList.add('is-open');
    }
  }
function closeAll() {
hoverTimer = setTimeout(function() {
panels.forEach(function(p) { p.classList.remove('is-active'); });
megaWrap.classList.remove('is-open');
    }, 250);
  }
triggers.forEach(function(el) {
el.addEventListener('mouseenter', function() { openPanel(this.dataset.megaTrigger); });
el.addEventListener('mouseleave', closeAll);
  });
panels.forEach(function(el) {
el.addEventListener('mouseenter', function() { clearTimeout(hoverTimer); });
el.addEventListener('mouseleave', closeAll);
  });
if (megaWrap) {
megaWrap.addEventListener('mouseenter', function() { clearTimeout(hoverTimer); });
  }
if (overlay) {
overlay.addEventListener('click', function() {
clearTimeout(hoverTimer);
hoverTimer = null;
panels.forEach(function(p) { p.classList.remove('is-active'); });
if (megaWrap) megaWrap.classList.remove('is-open');
    });
  }
/* ── Mobile Menu ── */
var mobileMenu = document.querySelector('[data-mobile-menu]');
function openMobileMenu() {
if (!mobileMenu) return;
mobileMenu.classList.add('is-open');
document.body.classList.add('is-scroll-locked');
  }
function closeMobileMenu() {
if (!mobileMenu) return;
mobileMenu.classList.remove('is-open');
document.body.classList.remove('is-scroll-locked');
  }
document.querySelectorAll('[data-menu-open]').forEach(function(btn) {
btn.addEventListener('click', openMobileMenu);
  });
document.querySelectorAll('[data-menu-close]').forEach(function(btn) {
btn.addEventListener('click', closeMobileMenu);
  });
/* ── Keyboard: close mega + mobile on Escape ── */
document.addEventListener('keydown', function(e) {
if (e.key === 'Escape') {
clearTimeout(hoverTimer);
panels.forEach(function(p) { p.classList.remove('is-active'); });
if (megaWrap) megaWrap.classList.remove('is-open');
closeMobileMenu();
    }
  });
/* Mobile Accordions */
document.querySelectorAll('[data-accordion]').forEach(function(btn) {
btn.addEventListener('click', function() {
var wasOpen = this.classList.contains('is-open');
document.querySelectorAll('[data-accordion]').forEach(function(other) {
other.classList.remove('is-open');
if (other.nextElementSibling) other.nextElementSibling.classList.remove('is-open');
      });
if (!wasOpen) {
this.classList.add('is-open');
if (this.nextElementSibling) this.nextElementSibling.classList.add('is-open');
      }
    });
  });
})();